var ContentPage = (function($, window) {
	var $window = $(window),
		$content = $('.page-content'),
		$sidebarNav = $('.sidebar__nav'),
		$stickyHeader = $('.masthead__sticky');

	var config = {
		$map: $('#entity-map')
	};

	// Google Maps config
	var maps = {
		map: null,
		markers: {},
		fakeMarkers: [],
		clusterer: null,
		activeWindow: null
	};

	var init = function() {
		generateMenu();

		initMap();

		if ($window.width() >= 768) {
			$sidebarNav.sticky({
				context: '.sidebar',
				topOffset: $stickyHeader.height() + 20
			});
		}
	};

	/**
	 * Initialize Google Maps after mapsLoaded() was called.
	 */
	var initMap = function() {
		if (!config.$map.length) {
			return;
		}

		var latLng = {
			lat: $(config.$map).data().lat,
			lng: $(config.$map).data().lng
		};

		maps.map = new google.maps.Map(config.$map[0], {
			center: latLng,
			zoom: 13,
			scrollwheel: false,
			draggable: !('ontouchend' in document), // disable on mobile
			styles: [
				{
					featureType: 'water',
					elementType: 'geometry',
					stylers: [{ color: '#e9e9e9' }, { lightness: 17 }]
				},
				{
					featureType: 'landscape',
					elementType: 'geometry',
					stylers: [{ color: '#f5f5f5' }, { lightness: 20 }]
				},
				{
					featureType: 'road.highway',
					elementType: 'geometry.fill',
					stylers: [{ color: '#ffffff' }, { lightness: 17 }]
				},
				{
					featureType: 'road.highway',
					elementType: 'geometry.stroke',
					stylers: [{ color: '#ffffff' }, { lightness: 29 }, { weight: 0.2 }]
				},
				{
					featureType: 'road.arterial',
					elementType: 'geometry',
					stylers: [{ color: '#ffffff' }, { lightness: 18 }]
				},
				{
					featureType: 'road.local',
					elementType: 'geometry',
					stylers: [{ color: '#ffffff' }, { lightness: 16 }]
				},
				{
					featureType: 'poi',
					elementType: 'geometry',
					stylers: [{ color: '#f5f5f5' }, { lightness: 21 }]
				},
				{
					featureType: 'poi.park',
					elementType: 'geometry',
					stylers: [{ color: '#dedede' }, { lightness: 21 }]
				},
				{
					elementType: 'labels.text.stroke',
					stylers: [
						{ visibility: 'on' },
						{ color: '#ffffff' },
						{ lightness: 16 }
					]
				},
				{
					elementType: 'labels.text.fill',
					stylers: [{ saturation: 36 }, { color: '#333333' }, { lightness: 40 }]
				},
				{ elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
				{
					featureType: 'transit',
					elementType: 'geometry',
					stylers: [{ color: '#f2f2f2' }, { lightness: 19 }]
				},
				{
					featureType: 'administrative',
					elementType: 'geometry.fill',
					stylers: [{ color: '#fefefe' }, { lightness: 20 }]
				},
				{
					featureType: 'administrative',
					elementType: 'geometry.stroke',
					stylers: [{ color: '#fefefe' }, { lightness: 17 }, { weight: 1.2 }]
				}
			]
		});

		addMarkers(
			[
				{
					adres_latitude: latLng.lat,
					adres_longitude: latLng.lng
				}
			],
			false
		);
	};

	/**
	 * Add markers for each record within GMaps.
	 *
	 * @param records
	 * @param showInfoWindow
	 */
	var addMarkers = function(records, showInfoWindow) {
		var infoWindow,
			markerIcon = config.$map.data('marker');

		$.each(records, function(i, record) {
			if (
				!record.hasOwnProperty('adres_latitude') ||
				!record.hasOwnProperty('adres_longitude')
			) {
				return true; // continue
			}

			record.coords = {
				lat: record.adres_latitude,
				lng: record.adres_longitude
			};

			var marker = new google.maps.Marker({
				icon: {
					url: markerIcon,
					scaledSize: new google.maps.Size(24, 34),
					origin: new google.maps.Point(0, 0),
					anchor: new google.maps.Point(0, 34)
				},
				map: maps.map,
				position: new google.maps.LatLng(record.coords.lat, record.coords.lng)
			});

			var title = record.hasOwnProperty('gebouw_naam')
				? record.gebouw_naam + ' ' + record.zaal_naam
				: record.naam;

			if (showInfoWindow) {
				var infoWindow = new google.maps.InfoWindow({
					content:
						'<strong>' +
						title +
						'</strong>' +
						'<br>' +
						record.adres +
						' ' +
						record.huisnummer +
						' ' +
						record.huisnummer_toevoeging
				});
			}

			marker.addListener('click', function() {
				if (maps.activeWindow) {
					maps.activeWindow.close();
				}

				maps.map.setCenter(marker.getPosition());
				maps.map.setZoom(15);

				if (infoWindow) {
					maps.activeWindow = infoWindow;
					infoWindow.open(maps.map, marker);
				}
			});

			maps.markers[record.id] = marker;
		});
	};

	/**
	 * Dynamically create the navigation menu based
	 * on the present page <h2> headings.
	 */
	var generateMenu = function() {
		var $topHeaders = $content.find('h2');

		if (!$topHeaders.length) {
			$sidebarNav.find('h5').text('Extra informatie');

			var $extraContent = $sidebarNav.find('.extra-content');

			if (!$extraContent.length) {
				var $sidebarCol = $sidebarNav.parents('.sidebar-col');
				var $contentCol = $sidebarCol.next();

				$sidebarNav.sticky('destroy').remove();

				$sidebarCol.remove();

				$contentCol.removeClass('col-md-9').addClass('col-md-12');
			}
		}

		$topHeaders.each(function() {
			var $heading = $(this);
			var selector = slugify($heading.text());

			$('<a/>', {
				class: 'anchor',
				id: selector
			}).insertBefore($heading);

			var $link = $('<a/>', {
				class: 'nav-link',
				href: '#' + selector,
				text: $heading.text()
			});

			$('<li/>', {
				class: 'nav-item',
				html: $link
			}).appendTo($sidebarNav.find('ul'));
		});

		$('body').scrollspy({
			target: '.sidebar__nav'
		});
	};

	return {
		init: init
	};
})(jQuery, window);
